import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isLoading: {
    loadingMakeCall: false,
    loadingEndCall: false,
    loadingAgentsOnline: false,
    loadingAnswerCall: false,
    loadingScreenCall: false,
    loadingHold: false,
    loadingTransfer: false,
    loadingConference: false,
    loadingConsult: false,
  },
  listStatus: [],
  initialStatus: "",
  statusCall: null,
  screen: null,
  isHold: false,
  listAgentsOnline: [],
  statusCreateRecord: null,
  statusCreateRecordMulti: null,
  fieldsMappingCallCenter: {},
  objectsToCall: {},
  dataSearchCore: [],
  alreadyUseExt: false,
  dataCallCenter:
    JSON.parse(localStorage.getItem("@ucrm_callCenter_data")) || [],
  phoneInCall: localStorage.getItem("@ucrm_callCenter_phoneInCall"),
  statusLinkInteraction: null,
  statusLinkInteractionMulti: null,
  isUpdateDrawer: false,
  isChangeTabData: {
    status: false,
    dataCall: {},
    record: {},
  },
  isDuplicate: false,
  droplistCallCache: {},
  formValueEdit: {},
  LinkingValueEdit: {},
};

const slice = createSlice({
  name: "callCenter",
  initialState,
  reducers: {
    resetEditForm(state, action) {
      let formValueEditTemp = { ...state.formValueEdit };
      delete formValueEditTemp[action.payload];

      let LinkingValueEditTemp = { ...state.LinkingValueEdit };
      delete LinkingValueEditTemp[action.payload];

      state.formValueEdit = formValueEditTemp;
      state.LinkingValueEdit = LinkingValueEditTemp;
    },
    setLinkingValueEdit(state, action) {
      state.LinkingValueEdit = {
        ...state.LinkingValueEdit,
        ...action.payload,
      };
    },
    setFormValueEdit(state, action) {
      state.formValueEdit = {
        ...state.formValueEdit,
        ...action.payload,
      };
    },
    setDroplistCallCache(state, action) {
      state.droplistCallCache = {
        ...state.droplistCallCache,
        ...action.payload,
      };
    },
    updateStatusCall(state, action) {
      state.statusCall = action.payload;
    },
    updateScreen(state, action) {
      state.screen = action.payload;
    },
    updateLoading(state, action) {
      switch (action.payload.type) {
        case "loadingMakeCall":
          state.isLoading.loadingMakeCall = action.payload.loading;
          break;
        case "loadingEndCall":
          state.isLoading.loadingEndCall = action.payload.loading;
          break;
        case "loadingAnswerCall":
          state.isLoading.loadingAnswerCall = action.payload.loading;
          break;
        case "loadingScreenCall":
          state.isLoading.loadingScreenCall = action.payload.loading;
          break;
        case "loadingHold":
          state.isLoading.loadingHold = action.payload.loading;
          break;
        case "loadingTransfer":
          state.isLoading.loadingTransfer = action.payload.loading;
          break;
        case "loadingConference":
          state.isLoading.loadingConference = action.payload.loading;
          break;
        case "loadingConsult":
          state.isLoading.loadingConsult = action.payload.loading;
          break;
        default:
          break;
      }
    },
    updateHold(state, action) {
      state.isHold = action.payload;
    },
    loadlistStatus() {},
    loadlistStatusSuccess(state, action) {
      state.listStatus = action.payload;
    },
    loadListReasonCode() {},
    loadListReasonCodeSuccess(state, action) {
      state.initialStatus = action.payload;
    },
    changeAgentStatus() {},
    makeCall(state) {
      state.isLoading.loadingMakeCall = true;
    },
    endCall(state) {
      state.isLoading.loadingEndCall = true;
    },
    holdCall(state) {
      state.isLoading.loadingHold = true;
    },
    unHoldCall(state) {
      state.isLoading.loadingHold = true;
    },
    loadAgentsOnline(state) {
      state.isLoading.loadingAgentsOnline = true;
    },
    loadAgentsOnlineSuccess(state, action) {
      state.isLoading.loadingAgentsOnline = false;
      state.listAgentsOnline = action.payload;
    },
    transferCall(state) {
      state.isLoading.loadingTransfer = true;
    },
    conferenceCall(state) {
      state.isLoading.loadingConference = true;
    },
    consultCall(state) {
      state.isLoading.loadingConsult = true;
    },
    answerCall(state) {
      state.isLoading.loadingAnswerCall = true;
    },
    updateInteraction() {},
    createRecordCallCenter() {},
    createRecordCallCenterSuccess(state, action) {
      state.statusCreateRecord = action.payload;
    },
    updateRecordCallCenter() {},
    updateRecordCallCenterResult(state, action) {
      state.statusCreateRecord = action.payload;
    },
    getFieldsMappingCallCenter() {},
    getFieldsMappingCallCenterSuccess(state, action) {
      state.fieldsMappingCallCenter = action.payload;
    },
    getObjectsToCall() {},
    getObjectsToCallResult(state, action) {
      state.objectsToCall = action.payload;
    },
    searchCoreCallCenter() {},
    searchCoreCallCenterResult(state, action) {
      state.dataSearchCore = action.payload;
    },
    createRecordCoreCallCenter() {},
    createRecordCoreCallCenterResult(state, action) {
      state.statusCreateRecord = action.payload;
    },
    createRecordCoreCallCenterMulti() {},
    createRecordCoreCallCenterMultiResult(state, action) {
      state.statusCreateRecordMulti = action.payload;
    },
    connectExt() {},
    setAlreadyUseExt(state, action) {
      state.alreadyUseExt = action.payload;
    },
    disconnectExt() {},
    storeDataCallCenter(state, action) {
      Object.entries(action.payload).forEach(([key, value]) => {
        state[key] = value;
      });
    },

    //ver3
    updateRecord(state) {
      state.isUpdateDrawer = false;
    },
    updateRecordSuccess(state) {
      state.isUpdateDrawer = true;
    },
    linkInteraction() {},
    loadNewInteraction() {},
    linkRecordCore() {},
    linkRecordCoreMulti() {},
    linkInteractionResult(state, action) {
      state.statusLinkInteraction = action.payload;
    },
    linkInteractionMultiResult(state, action) {
      state.statusLinkInteractionMulti = action.payload;
    },
    triggerChangeTabData(state, action) {
      state.isChangeTabData = action.payload;
    },
    setIsDuplicate(state, action) {
      state.isDuplicate = action.payload;
    },
  },
});

//Reducer
export default slice.reducer;

//Actions
export const {
  resetEditForm,
  setLinkingValueEdit,
  setFormValueEdit,
  setDroplistCallCache,
  updateStatusCall,
  updateScreen,
  updateLoading,
  updateHold,
  loadlistStatus,
  loadlistStatusSuccess,
  loadListReasonCode,
  loadListReasonCodeSuccess,
  changeAgentStatus,
  makeCall,
  endCall,
  holdCall,
  unHoldCall,
  loadAgentsOnline,
  loadAgentsOnlineSuccess,
  transferCall,
  conferenceCall,
  consultCall,
  answerCall,
  updateInteraction,
  createRecordCallCenter,
  createRecordCallCenterSuccess,
  updateRecordCallCenter,
  updateRecordCallCenterResult,
  getFieldsMappingCallCenter,
  getFieldsMappingCallCenterSuccess,
  getObjectsToCall,
  getObjectsToCallResult,
  searchCoreCallCenter,
  searchCoreCallCenterResult,
  createRecordCoreCallCenter,
  createRecordCoreCallCenterResult,
  createRecordCoreCallCenterMulti,
  createRecordCoreCallCenterMultiResult,
  linkRecordCore,
  linkRecordCoreMulti,
  connectExt,
  setAlreadyUseExt,
  disconnectExt,
  storeDataCallCenter,
  updateRecord,
  updateRecordSuccess,
  linkInteraction,
  loadNewInteraction,
  linkInteractionResult,
  linkInteractionMultiResult,
  triggerChangeTabData,
  setIsDuplicate,
} = slice.actions;
